import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { ArrowLeftIcon } from 'assets/icons'
import { Http, Gtm } from 'helpers'
import { Button } from 'components'
import { API, STORAGE_KEYS, PAGE_TYPES } from 'src/constants'
import { BasketTypes, GTMTypes } from 'types'

interface Props extends RouteComponentProps<any> {
    onCancel: Function,
    basket: BasketTypes.Item[],
    clearBasket: Function
}

interface State {
    loading: boolean,
}

class Order extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('page-product-detail')

        // GTM
        Gtm.pushPageType(PAGE_TYPES.CHECKOUT)
        const products: GTMTypes.Event[] = []
        this.props.basket.map((item: any) =>
            products.push({
                name: `${item.productGroupName} - ${item.name}`,
                id: item.articleId,
                brand: 'New Surplus Order',
                variant: item.formId,
                quantity: item.quantity
            })
        )
        Gtm.pushFlowEvent('checkout', {
            checkout: {
                actionField: {
                    step: 1
                },
                products: products
            }

        })
        // End GTM
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('page-product-detail')
    }

    public handleClick = () => {
        this.props.onCancel()
    }

    public submitOrder = (basket: BasketTypes.Item[], callback: Function) => {

        this.setState({
            loading: true
        })

        const order = basket.map((val: any, index: number) => {
           let requestObj = {
                id: val.id,
                quantity: val.quantity,
                week: val.week,
                year: val.year
           }
           return requestObj
        })

        const checkClientStorage = localStorage.getItem(STORAGE_KEYS.CLIENT)
        const client = checkClientStorage ? JSON.parse(checkClientStorage) : ''

        Http(API.host + API.endpoints.order + '?companyId=10' + (client && '&clientId=' + client.id), 'POST', order)
            .then((data: any) => {
                callback()
                this.setState({
                    loading: false
                })

                // GTM
                Gtm.pushPageType(PAGE_TYPES.PURCHASE)
                const products: GTMTypes.Event[] = []
                basket.map((item: any) =>
                    products.push({
                        name: `${item.productGroupName} - ${item.name}`,
                        id: item.articleId,
                        brand: 'New Surplus Order',
                        variant: item.formId,
                        quantity: item.quantity
                    })
                )
                Gtm.pushFlowEvent('purchase', {
                    purchase: {
                        actionField: {
                            id: data.orderId,
                            affiliation: 'www.florensis.nl',
                            revenue: '',
                            tax: '',
                            shipping: ''
                        },
                        products: products
                    }
                })

                // End GTM
                this.props.history.push({
                    pathname: '/thankyou',
                    state: { orderId: data.orderId }
                })
            })
            .catch((error: Object) => {
                alert(error)
                this.setState({
                    loading: false
                })
            })
    }

    public render() {
        return (
            <section className="page-layout">
                <header>
                    <a href="#" className="button--link" onClick={this.handleClick}>
                        <ArrowLeftIcon fill="#000000"/>
                        Back
                    </a>
                </header>
                <main>
                    <h1 className="u-margin-top--md">Do you<br/> want to <br/>order?</h1>
                </main>
                <footer>
                    <a href="#" className="text-link u-text--centered" onClick={this.handleClick}>
                        No, I would like to make a change
                    </a>
                    <Button
                        full={true}
                        loading={this.state.loading}
                        className="u-margin-top--md"
                        onClick={() => this.submitOrder(this.props.basket, this.props.clearBasket)}
                    >Yes, place order
                    </Button>
                </footer>
            </section>
        )
    }
}

export default withRouter(Order)



// WEBPACK FOOTER //
// ./src/containers/Order/index.tsx